
import axios from "axios";
const md5 = require('blueimp-md5');
import qs from 'qs';
import { Message } from 'element-ui';

export let ossUrl = 'https://branew-pic.oss-cn-beijing.aliyuncs.com/';

axios.defaults.timeout = 5000;
axios.defaults.baseURL ='http://www.branew.com.cn/gw-front';
// axios.defaults.baseURL ='http://123.57.236.4:20312/gw-front';
// axios.defaults.baseURL ='http://192.168.1.115:20312/gw-front';


//http request 拦截器
axios.interceptors.request.use(
  config => {
    // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
    config.data = JSON.stringify(config.data);
    config.headers = {
      'Content-Type':'application/x-www-form-urlencoded'
    }
    // if(token){
    //   config.params = {'token':token}
    // }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);


//http response 拦截器
// axios.interceptors.response.use(
//   response => {
//     if(response.data.errCode ==2){
//       router.push({
//         path:"/login",
//         querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
//       })
//     }
//     return response;
//   },
//   error => {
//     return Promise.reject(error)
//   }
// )


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url,params={}){
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

 export function post(url,data={}){
   return new Promise((resolve,reject) => {
     axios.post(url,qs.stringify(data))
          .then(response => {
            resolve(response.data);
          },err => {
            reject(err)
          })
   })
 }

 /**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.patch(url,data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

 /**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.put(url,data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}


const zone = '';
const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
const signSecret = 'jXLHrbVbdyC3aDjxU3utK4AmHH6et8Q26aeuUQbatZP8k8R6Jc'; 

function randomString(length) {
  return Array(length).join().split(',').map(function () {
    return chars.charAt(Math.floor(Math.random() * chars.length));
  })
    .join('');
};

const http = axios.create({baseURL: `http://www.branew.com.cn/gw-front/api/v2527RCHirb3PP7T`, timeout: 100000});
// const http = axios.create({baseURL: `http://123.57.236.4:20312/gw-front/api/v2527RCHirb3PP7T`, timeout: 100000});

export const callAPI = (method, params) => {
  let apiParams = {nonce: randomString(10), timestamp: Date.now(), payload: params};

  let postBody = JSON.stringify(apiParams);

  let apiMethod = zone + method;
  let apiDigest = md5(postBody, signSecret);

  return http.post('exec', postBody, {
    headers: {'API-MAC': apiMethod + ' ' + apiDigest, 'Content-Type': 'text/plain'}
  });
};


// export const http = axios.create({timeout: 100000});

// export const callAPI = (method, params = null, target) => {
//   let apiParams = {nonce: randomString(10), timestamp: Date.now(), payload: params};

//   let postBody = JSON.stringify(apiParams);

//   let apiMethod = zone + method;
//   let apiDigest = md5(postBody, signSecret);
//   if (!target) {
//     return http.post(`http://192.168.1.130:20312/gw-front/api/v2527RCHirb3PP7T/exec`, postBody, {
//       headers: {
//         'API-MAC': apiMethod + ' ' + apiDigest,
//         'Content-Type': 'text/plain'
//       }
//     });
//   } else {
//     return http.post(`http://${target}/api/v2527RCHirb3PP7T/exec`, postBody, {
//       headers: {
//         'API-MAC': apiMethod + ' ' + apiDigest,
//         'Content-Type': 'text/plain'
//       }
//     });
//   }
// };
